import $ from 'jquery';
import { MDCFormField } from '@material/form-field';
import { MDCTextField } from '@material/textfield';
import { MDCRadio } from '@material/radio';
import { MDCCheckbox } from '@material/checkbox';

export const initialize = function () {
  $('.mdc-text-field').each((key, el) => {
    const textField = new MDCTextField(el);
    /** @type {HTMLTextAreaElement} inputEl */
    const inputEl = textField.input_;
    const maxLength = inputEl.maxLength;
    if (maxLength > 0 && inputEl) {
      const formGroupEl = $(el).parents('.mdc-form-group').get(0);
      const characterCounter = formGroupEl.querySelector(
        '.FormElement__CharacterCounter'
      );
      const updateCounter = function () {
        if (!characterCounter) {
          return;
        }

        const length = textField.input_.value.length;
        characterCounter.innerText = `${length} / ${maxLength}`;
      };
      updateCounter();
      textField.listen('input', updateCounter);
    }
  });
  $('.mdc-form-field').each((key, el) => {
    const formField = new MDCFormField(el);

    const radioEl = el.querySelector('.mdc-radio');
    if (radioEl) {
      const radio = new MDCRadio(radioEl);
      formField.input = radio;
      return;
    }

    const checkBoxEl = el.querySelector('.mdc-checkbox');
    if (checkBoxEl) {
      const checkbox = new MDCCheckbox(checkBoxEl);
      formField.input = checkbox;
      return;
    }
  });
};
